var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.75293C4 7.69206 4.42143 6.67465 5.17157 5.9245C5.92172 5.17436 6.93913 4.75293 8 4.75293H16C17.0609 4.75293 18.0783 5.17436 18.8284 5.9245C19.5786 6.67465 20 7.69206 20 8.75293V16.7529C20 17.8138 19.5786 18.8312 18.8284 19.5814C18.0783 20.3315 17.0609 20.7529 16 20.7529H8C6.93913 20.7529 5.92172 20.3315 5.17157 19.5814C4.42143 18.8312 4 17.8138 4 16.7529V8.75293Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.7529C9 13.5486 9.31607 14.3116 9.87868 14.8743C10.4413 15.4369 11.2044 15.7529 12 15.7529C12.7956 15.7529 13.5587 15.4369 14.1213 14.8743C14.6839 14.3116 15 13.5486 15 12.7529C15 11.9573 14.6839 11.1942 14.1213 10.6316C13.5587 10.069 12.7956 9.75293 12 9.75293C11.2044 9.75293 10.4413 10.069 9.87868 10.6316C9.31607 11.1942 9 11.9573 9 12.7529Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.25293V8.26293",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.75293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.bb2d09828ee853fc07c08c61a16c1671.svg";
export { ForwardRef as ReactComponent };